import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "react-quill/dist/quill.snow.css";
// import "./customForm.scss";
import uploadIcon from "./../../../Assets/icons/uploadicon.svg";
import jobcardIcon from "../../../Assets/icons/JobCardPlusIcon.svg";
import pdfIcon from "../../../Assets/icons/pdfIcon.png";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import Switch from "react-switch";
import { updateLocale } from "moment";

const DynamicForm = ({
  formConfig,
  formData,
  cities,
  setFormData = () => {},
  validationErrors,
  setValidationErrors = () => {},
  showParentDesignation,
  setShowParentDesignation = () => {},
  onclickOpenFrom = () => {},
  exshowroomprice = "",
}) => {
  const [fileNames, setFileNames] = useState({});
  const [pincode, setPincode] = useState("");
  const token = localStorage.getItem("authToken");
  const datePickerRefs = useRef({});

  const handleChange = (name, value, type) => {
    console.log(name, value, "namevalueforfile");

    if (type === "checkbox" || type === "toggle") {
      if (name === "exchange" && value === true) {
        console.log("name>>", name, value);
        setShowParentDesignation(true);
      }
      setFormData({ ...formData, [name]: value });
      console.log("formdata???", formData);
    } else if (type === "file") {
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    validateField(name, value);
  };
  const handleDropdownChange = (name, selectedOption) => {
    console.log("selected options", name, selectedOption);

    if (name === "productName") {
      setFormData({
        ...formData,
        [name]: selectedOption?.value,
        subproductName: null,
      });
    } else if (name === "city") {
      const selectedCity = cities?.find(
        (city) => city.city_id === selectedOption?.value
      );
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOption.label,
        city_id: selectedOption?.value,
        state: selectedCity.state_name,
        state_id: selectedCity.state_id,
        country: selectedCity.country_name,
        country_id: selectedCity.country_id,
      }));
    } else {
      setFormData({ ...formData, [name]: selectedOption?.value });
    }
    validateField(name, selectedOption ? selectedOption?.value : null);
  };
  const validateField = (name, value) => {
    console.log("multiselectvalues", value);

    const fieldConfig = formConfig?.find((field) => field.name === name);
    if (fieldConfig && fieldConfig?.validation) {
      const {
        required,
        minLength,
        maxLength,
        maxValue,
        maxAmount,
        pattern,
        message,
        message1,
        accept,
        responseerrormessage,
      } = fieldConfig.validation;
      let error = "";
      // if(name==="discount"){

      //   if(Number(value)>exshowroomprice){
      //     console.log("disocuntformdata",value);

      //     error="Discount amount should be less than exshowroom price"
      //   }
      //   if(formData?.discount_type && Number(value)>100){
      //     console.log("disocuntformdata",value);

      //     error="Discount percentage should be less than 100"
      //   }
      // }
      if (name === "uploadDocument") {
        const file = value?.name;
        const fileExtension = file?.split(".").pop().toLowerCase();

        console.log("fileExtension", fileExtension);
        if (accept && !accept.includes(fileExtension)) {
          error = `Invalid file format. Allowed formats: ${accept}`;
        }
      }
      if (name === "gstno") {
        const panValue = formData?.panno;
        console.log("valuelength", value?.length);

        if (value?.length !== 0) {
          if (
            !panValue ||
            panValue.length !== 10 ||
            !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panValue)
          ) {
            error = "Invalid PAN format, GST validation requires a valid PAN";
          } else if (value.length !== 15) {
            error = "GST number must be 15 characters long";
          } else {
            const gstPanPart = value.substring(2, 12);
            if (gstPanPart !== panValue) {
              error = "GST number is not valid as per the PAN number";
            }
          }
        }
      }
      console.log("responseerrormessage", responseerrormessage);
      if (
        required &&
        (value === undefined ||
          value === null ||
          value === "" ||
          (Array.isArray(value) && value.length === 0))
      ) {
        console.log("accessmodulevalue", value);
        error = "This field is required*";
      } else if (value?.length > 0 && pattern && !pattern.test(value)) {
        error = message1 ? `${message1}` : `${message}`;
      } else if (value?.length > 0 && value.length < minLength) {
        error = `Minimum length ${minLength} characters`;
      } else if (value?.length > 0 && maxLength && value.length > maxLength) {
        error = `Maximum length ${maxLength} characters`;
      } else if (required && maxValue && value > maxValue) {
        error = `Quantity  Exceeded`;
      } else if (value?.length > 0 && responseerrormessage?.length > 0) {
        error = `${responseerrormessage}`;
      }
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    }
  };

  // const handleFileChange = (e, name) => {
  //   const files = e.target.files;
  //   const newFiles = Array.from(files);

  //   setFormData((prevData) => {
  //     const existingFiles = prevData[name] || [];

  //     // Limit to a maximum of 5 files
  //     if (existingFiles.length + newFiles.length > 5) {
  //       alert(
  //         `You can only upload a maximum of 5 images. You currently have ${existingFiles.length} uploaded.`
  //       );
  //       return prevData; // Return the previous data without changes
  //     }

  //     const updatedFiles = [...existingFiles, ...newFiles];

  //     return {
  //       ...prevData,
  //       [name]: updatedFiles,
  //     };
  //   });

  //   // Optional: Update file names for UI display
  //   setFileNames((prevNames) => ({
  //     ...prevNames,
  //     [name]: newFiles.map((file) => file.name).join(", "),
  //   }));
  // };

const handleFileChange = (e, name) => {
  const files = Array.from(e.target.files);

  // Allowed extensions & size
  const allowedExtensions = ["jpg", "jpeg", "png", "pdf"];
  const maxSize = 20 * 1024 * 1024; // 20MB

  // ---------- VALIDATION ----------
  for (let file of files) {
    const fileExtension = file.name.split(".").pop().toLowerCase();

    // File type validation
    if (!allowedExtensions.includes(fileExtension)) {
      alert("Only JPG, JPEG, PNG and PDF files are allowed.");

      setValidationErrors((prev) => ({
        ...prev,
        [name]: "Invalid file type. Only JPG, JPEG, PNG and PDF allowed.",
      }));

      return;
    }

    // File size validation
    if (file.size > maxSize) {
      alert("File size cannot exceed 20MB.");

      setValidationErrors((prev) => ({
        ...prev,
        [name]: "File size cannot exceed 20MB.",
      }));

      return;
    }
  }

  // Clear validation error if all files are valid
  setValidationErrors((prev) => ({
    ...prev,
    [name]: "",
  }));

  // ---------- STATE UPDATE ----------
  setFormData((prevData) => {
    const existingFiles = prevData[name] || [];

    // Limit to maximum of 5 files
    if (existingFiles.length + files.length > 5) {
      alert(
        `You can only upload a maximum of 5 files. You currently have ${existingFiles.length} uploaded.`
      );
      return prevData;
    }

    return {
      ...prevData,
      [name]: [...existingFiles, ...files],
    };
  });

  // ---------- UI FILE NAMES ----------
  setFileNames((prevNames) => ({
    ...prevNames,
    [name]: files.map((file) => file.name).join(", "),
  }));
};

  // const handleRemoveFile = (name, index) => {
  //   console.log("deletedimagename", name);

  //   setFormData((prevData) => {
  //     // Ensure that the array exists before filtering
  //     const existingFiles = prevData[name] || [];
  //     console.log("existingfiles", existingFiles);

  //     // Check if the index is valid
  //     if (index >= 0 && index < existingFiles.length) {
  //       const updatedFiles = existingFiles.filter((_, i) => i !== index);
  //       return { ...prevData, [name]: updatedFiles };
  //     }

  //     return prevData; // If index is out of bounds, return previous data
  //   });

  //   // Update file names for UI display (optional)
  //   setFileNames((prevNames) => {
  //     const existingFileNames = (formData[name] || [])
  //       .filter((_, i) => i !== index)
  //       .map((file) => file.name)
  //       .join(", ");

  //     return { ...prevNames, [name]: existingFileNames };
  //   });
  // };
  const handleRemoveFile = (name, index) => {
    setFormData((prevData) => {
      const existingFiles = prevData[name] || [];

      // Filter out the removed file
      const updatedFiles = existingFiles.filter((_, i) => i !== index);

      // Update fileNames based on the updatedFiles
      setFileNames((prevNames) => ({
        ...prevNames,
        [name]: updatedFiles.map((file) => file.name).join(", "),
      }));

      return { ...prevData, [name]: updatedFiles };
    });
  };

  // Render file previews with a Remove button
  // const renderFilePreviews = (files, fieldName) => {
  //   return files.map((file, index) => {
  //     const fileURL = URL.createObjectURL(file);
  //     return (
  //       <div
  //         key={index}
  //         style={{ marginTop: "10px", display: "flex", marginRight: "10px" }}
  //       >
  //         <img
  //           src={fileURL}
  //           alt="Uploaded Preview"
  //           style={{
  //             width: "20px",
  //             height: "20px",
  //             objectFit: "cover",
  //             marginBottom: "10px",
  //           }}
  //         />
  //         <p>{file.name}</p>
  //         {/* <button onClick={() => handleRemoveFile(fieldName, index)}>Remove</button> */}
  //       </div>
  //     );
  //   });
  // };

  //   const handleRemoveFile = (fieldName, index) => {
  //   const updatedFiles = [...formData[fieldName]];
  //   updatedFiles.splice(index, 1);

  //   setFormData((prev) => ({
  //     ...prev,
  //     [fieldName]: updatedFiles,
  //   }));
  // };

  const renderFilePreviews = (files, fieldName) => {
    return files.map((file, index) => {
      const fileURL = URL.createObjectURL(file);

      return (
        <div
          key={index}
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <img
            src={fileURL}
            alt="Uploaded Preview"
            style={{
              width: "20px",
              height: "20px",
              objectFit: "cover",
            }}
          />

          <p style={{ margin: 0 }}>{file.name}</p>

          {/* Delete Button */}
          <button
            type="button"
           onClick={() => handleRemoveFile(fieldName, index)}
            style={{
              background: "red",
              border: "none",
              color: "white",
              borderRadius: "4px",
              padding: "3px 6px",
              cursor: "pointer",
              fontSize: "12px",
            }}
          >
            ✕
          </button>
        </div>
      );
    });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: "200px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
        ? "#fff"
        : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const handleFileDrop = (e, name) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setFormData({ ...formData, [name]: file });
    setFileNames({ ...fileNames, [name]: file.name });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  //   const handleFileChange = (e, name) => {
  //     const files = e.target.files;
  //     const newFiles = Array.from(files);

  //     setFormData((prevData) => {
  //       const existingFiles = prevData[name] || [];

  //       // Limit to a maximum of 5 files
  //       if (existingFiles.length + newFiles.length > 5) {
  //         alert("You can only upload a maximum of 5 images.");
  //         return prevData; // Return the previous data without changes
  //       }

  //       return {
  //         ...prevData,
  //         [name]: [...existingFiles, ...newFiles],
  //       };
  //     });

  //     // Optional: Update file names for UI display
  //     setFileNames((prevNames) => ({
  //       ...prevNames,
  //       [name]: newFiles.map(file => file.name).join(', '),
  //     }));
  //   };

  const renderField = (field) => {
    const additionalClass = field.gridClass ? ` ${field.gridClass}` : "";
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <input
              type={field?.type}
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
              // minLength={2}
              maxLength={field?.validation && field?.validation?.maxLength}
              onChange={(e) =>
                handleChange(field.name, e.target.value, field.type)
              }
              className={`form-control ${
                validationErrors[field?.name] && "is-invalid"
              }`}
            />
            {validationErrors[field?.name] && (
              <div className="error-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );

      case "dropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>
            <div
              className={`dropdown-wrapper ${
                field?.iscustomer ? "isCustomer" : ""
              }`}
              style={{ display: "flex", alignItems: "center" }}
            >
              <div style={{ flexGrow: 1 }}>
                <Select
                  isClearable
                  key={field.name}
                  name={field.name}
                  isDisabled={field?.disabled}
                  options={field?.options}
                  styles={customStyles}
                  defaultValue={formData[field.name] || field.defaultValue}
                  value={
                    field?.options?.find(
                      (option) => option?.value === formData[field?.name]
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    handleDropdownChange(field?.name, selectedOption)
                  }
                  menuPlacement={field?.dropdownOptionsListPosition || "auto"}
                />
              </div>
              {field?.iscustomer && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={onclickOpenFrom}
                >
                  <img src={jobcardIcon} alt="Job Card Icon" />
                </div>
              )}
            </div>
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );

      case "checkbox":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label className="form-label d-block mb-2">
              <input
                type="checkbox"
                checked={formData[field.name] || false}
                onChange={(e) =>
                  setFormData({ ...formData, [field.name]: e.target.checked })
                }
              />{" "}
              {field.label}
            </label>
          </div>
        );

      case "file":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUpload">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) => handleFileChange(e, field.name)}
                      multiple={true} // Enable multiple file uploads
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} alt="upload" />
                        {fileNames[field.name] || (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              (File Format - JPG, PNG, PDF)
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {/* {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )} */}
              {validationErrors[field.name] && (
                <div className="customerror">
                  {validationErrors[field.name]}
                </div>
              )}

              {/* Render the uploaded files as thumbnails */}
              {/* {formData[field.name] && renderFilePreviews(formData[field.name])} */}
              {renderFilePreviews(formData[field.name] || [], field.name)}
            </div>
          </>
        );
      case "toggle":
        return (
          <div
            key={field?.name}
            className={`${additionalClass} mt-3 mb-3 togglecontainer`}
          >
            <Switch
              checked={formData[field?.name] || false}
              onChange={(checked) =>
                handleChange(field?.name, checked, "toggle")
              }
              onColor="#7BD755"
              onHandleColor="#7BD755"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
              disabled={field?.disabled ? true : false}
            />
            <label className="mt-3 mb-3">{field.label}</label>
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="row">
      {formConfig?.map((field) => (
        <div key={field?.name} className={`${field.gridClass}`}>
          {(showParentDesignation || field?.isVisible !== false) &&
            renderField(field)}
        </div>
      ))}
    </div>
  );
};

export default DynamicForm;
